export default __webpack_public_path__ + "static/media/follow-events.c1373bd9.webp";